import { installDomCapture, connectionInfo } from "./capture";
import { flushLogs, getDeviceId, logEvent } from "./logger";
import { installNetworkCapture } from "./network";
import { startStallWatch } from "./stallWatch";
import { bundleVersion, startLogSync } from "./sync";

export { flushLogs, getDeviceId, isLoggingEnabled, logEvent, setLogActor, setLoggingEnabled } from "./logger";
export { handleServerSyncRequest, syncLogs } from "./sync";

let started = false;

/**
 * Called once from src/index.js, before React renders, so errors during the first
 * render and the very first requests are captured too.
 */
export function startInteractionLogging() {
  if (started) return;
  started = true;
  try {
    installNetworkCapture();
    installDomCapture();
    startLogSync();
    // A freeze names itself: how long, on which screen (2026-10-24).
    startStallWatch({ log: logEvent, flush: flushLogs });
    logEvent("app_start", {
      bundle: bundleVersion(),
      device_id: getDeviceId(),
      user_agent: navigator.userAgent,
      screen: `${window.screen?.width}x${window.screen?.height}@${window.devicePixelRatio}`,
      viewport: `${window.innerWidth}x${window.innerHeight}`,
      // Plain HTTP is not a secure context: no service worker, no crypto.subtle (so no
      // Captain Mesh), and a WebSocket that can never connect through the redirect.
      // Logged at startup because it silently explains a whole class of failures.
      secure_context: window.isSecureContext,
      standalone: window.matchMedia?.("(display-mode: standalone)")?.matches || false,
      service_worker: "serviceWorker" in navigator,
      ...connectionInfo(),
    });
  } catch {
    /* the app starts whether or not logging could */
  }
}
